import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import NewCasePage from "./pages/NewCasePage";
import CaseDetailPage from "./pages/CaseDetailPage";
import BuchhaltungPage from "./pages/BuchhaltungPage";
import KundenPage from "./pages/KundenPage";
import AufgabenPage from "./pages/AufgabenPage";
import TerminePage from "./pages/TerminePage";
import LegalPage from "./pages/LegalPage";
import EinstellungenPage from "./pages/EinstellungenPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/neuer-fall" element={<NewCasePage />} />
        <Route path="/neuer-fall/:type" element={<NewCasePage />} />
        <Route path="/new-case" element={<NewCasePage />} />
        <Route path="/fall/:caseId" element={<CaseDetailPage />} />
        <Route path="/buchhaltung" element={<BuchhaltungPage />} />
        <Route path="/kunden" element={<KundenPage />} />
        <Route path="/aufgaben" element={<AufgabenPage />} />
        <Route path="/termine" element={<TerminePage />} />
        <Route path="/einstellungen" element={<EinstellungenPage />} />
        <Route path="/impressum" element={<LegalPage />} />
        <Route path="/datenschutz" element={<LegalPage />} />
        <Route path="/barrierefreiheit" element={<LegalPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
